const POST_LOGIN_REDIRECT_URL_KEY = 'post-login-url';
const POST_PROFILE_EDIT_REDIRECT_URL_KEY = 'post-profile-save-url';

interface IUseRedirectPostLogin {
  postLoginRedirectPath: string;
  setPostLoginRedirectPath: (url: string) => void;
  clearPostLoginRedirectPath: () => void;
}

export const useRedirectPostLogin = (): IUseRedirectPostLogin => ({
  postLoginRedirectPath: window.sessionStorage.getItem(POST_LOGIN_REDIRECT_URL_KEY) || '/auth/projects',
  setPostLoginRedirectPath: (url: string) => window.sessionStorage.setItem(POST_LOGIN_REDIRECT_URL_KEY, url),
  clearPostLoginRedirectPath: () => window.sessionStorage.removeItem(POST_LOGIN_REDIRECT_URL_KEY),
});

interface IUseRedirectPostProfileEdit {
  postProfileEditRedirectPath: string;
  setPostProfileEditRedirectPath: (url: string) => void;
  clearPostProfileEditRedirectPath: () => void;
}

export const useRedirectPostProfileEdit = (): IUseRedirectPostProfileEdit => ({
  postProfileEditRedirectPath: window.sessionStorage.getItem(POST_PROFILE_EDIT_REDIRECT_URL_KEY) || '/auth/profile',
  setPostProfileEditRedirectPath: (url: string) =>
    window.sessionStorage.setItem(POST_PROFILE_EDIT_REDIRECT_URL_KEY, url),
  clearPostProfileEditRedirectPath: () => window.sessionStorage.removeItem(POST_PROFILE_EDIT_REDIRECT_URL_KEY),
});
